// export { }
// voir https://react-bootstrap.netlify.app/components/overlays/#tooltip-props pour pas avoir mui que pour ça

import { Placement } from "@popperjs/core";
import React from "react";
import { usePopperTooltip } from "react-popper-tooltip";

interface IProps {
  content?: string;
  image?: string;
  placement?: Placement;
  popICon?:React.ReactNode;
}
const InfoCard: React.FC<IProps> = ({ content, image, placement,popICon }) => {
  const {
    getArrowProps,
    getTooltipProps,
    setTooltipRef,
    setTriggerRef,
    visible,
  } = usePopperTooltip({
    placement: placement ? placement : "top",
    offset: [0, 0],
  });
  return (
    <>
      <div ref={setTriggerRef}>
        {popICon ? popICon : 
          <i
            className="bi-info-circle"
            data-bs-toggle="tooltip"
            data-bs-placement="top" //right
          />
        }
      </div>
      {visible && (
        <div
          ref={setTooltipRef}
          {...getTooltipProps({
            className: "card",
            style: { zIndex: 1000 },
            center: true,
          })}
        >
          <div {...getArrowProps({})}></div>
          {content && (
            <div className="info-card-body display-linebreak text-start">
              {content}
            </div>
          )}
          {image && (
            <div className="info-card-body display-linebreak row">
              {image && (
                <img src={image} className={"App-tooltip-image col-l-12"} />
              )}
            </div>
          )}
        </div>
      )}
    </>
  );
};

export default InfoCard;
